import { default as domainCampus } from './campus/services'
import { default as domainCompanyBranch } from './branch/services'
import { default as domainCompany } from './company/services'
import { default as domainEducationalGroup } from './educacional-group/services'
import { default as domainInstitution } from './institution/services'

export default {
    domainCampus,
    domainCompanyBranch,
    domainCompany,
    domainInstitution,
    domainEducationalGroup
}